var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/service_tracking/web/service_tracking/~/core-js/modules/_has.js
// module id = ../../../../core-js/modules/_has.js
// module chunks = 0